import { styled } from '@mui/material/styles';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const CardContentStyled = styled(CardContent)({
  padding: '24px!important',
  gap: '8px',
  display: 'flex',
  flexDirection: 'column',
});
